var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.108 3.775a.625.625 0 0 0-.883-.884L2.89 16.225a.624.624 0 1 0 .884.883l2.372-2.373c1.14.537 2.45.89 3.853.89 2.236 0 4.241-.898 5.683-2.005.723-.554 1.32-1.172 1.74-1.78.41-.59.702-1.238.702-1.84 0-.603-.292-1.25-.701-1.841-.422-.608-1.018-1.225-1.74-1.78a9.93 9.93 0 0 0-.693-.486l2.117-2.118ZM14.083 6.8l-1.476 1.475a3.125 3.125 0 0 1-4.33 4.331l-1.182 1.18a7.709 7.709 0 0 0 2.905.588c1.905 0 3.65-.77 4.922-1.746.635-.488 1.137-1.015 1.475-1.501.35-.503.478-.898.478-1.128 0-.231-.129-.625-.478-1.129-.338-.485-.84-1.013-1.475-1.5-.26-.2-.54-.392-.839-.57Zm-4.892 4.891a1.875 1.875 0 0 0 2.5-2.5l-2.5 2.5Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 4.375c.86 0 1.687.133 2.46.36a.202.202 0 0 1 .082.338l-.686.688a.21.21 0 0 1-.198.056A7.393 7.393 0 0 0 10 5.625c-1.906 0-3.65.77-4.923 1.746-.635.487-1.136 1.015-1.474 1.5-.35.504-.478.898-.478 1.129 0 .23.128.625.478 1.128.294.425.714.881 1.24 1.315.096.079.105.225.016.314l-.59.59a.204.204 0 0 1-.277.014 7.93 7.93 0 0 1-1.416-1.52c-.41-.591-.701-1.239-.701-1.841 0-.602.292-1.25.7-1.84.422-.608 1.02-1.226 1.74-1.78C5.759 5.272 7.764 4.374 10 4.374Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 6.875c.099 0 .197.004.293.013.164.016.223.212.107.329l-1.01 1.01a1.88 1.88 0 0 0-1.163 1.162L7.217 10.4c-.117.117-.312.057-.328-.107A3.125 3.125 0 0 1 10 6.875Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeclose);
export default __webpack_public_path__ + "static/media/eyeclose.b56bf1eac53cfd2ec1c8a790c63be72d.svg";
export { ForwardRef as ReactComponent };